import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { getHandoutCoupons } from "src/api/coupon";
const useLegacyCouponReceive = (param)=>{
    const { data: handoutCoupons  } = useQuery([
        "getHandoutCoupons",
        param.id
    ], ()=>{
        return getHandoutCoupons({
            productId: String(param.id),
            productPrice: param.price
        });
    }, {
        retry: 0
    });
    const filteredHasCoupon = useCallback(()=>{
        if (!handoutCoupons || !handoutCoupons.coupons) return null;
        if (handoutCoupons.coupons.length) {
            return handoutCoupons.coupons.filter((coupon)=>!coupon.hasBeenReceived);
        }
    }, [
        handoutCoupons
    ]);
    const couponStatus = useMemo(()=>{
        var _handoutCoupons_coupons, _filteredHasCoupon;
        if (!handoutCoupons || !((_handoutCoupons_coupons = handoutCoupons.coupons) === null || _handoutCoupons_coupons === void 0 ? void 0 : _handoutCoupons_coupons.length)) return "no-coupons";
        if (((_filteredHasCoupon = filteredHasCoupon()) === null || _filteredHasCoupon === void 0 ? void 0 : _filteredHasCoupon.length) === 0) return "all-received";
        return "has-unreceived";
    }, [
        handoutCoupons,
        filteredHasCoupon
    ]);
    return {
        handoutCoupons,
        filteredHasCoupon,
        couponStatus
    };
};
export default useLegacyCouponReceive;
